import React, { useState, useCallback, useMemo } from 'react';
import { Text } from '../Text/Text.es.js';
import { StarFilled, StarHalfFilled, StarOutlined, StarRating as StarRating$1 } from './styled.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StarRating = (_a) => {
  var _b = _a, {
    currentRating = 0,
    maxRating = 5,
    isActive = false,
    onClick,
    type = "default",
    size = "md",
    variant = "default"
  } = _b, rest = __objRest(_b, [
    "currentRating",
    "maxRating",
    "isActive",
    "onClick",
    "type",
    "size",
    "variant"
  ]);
  const [hoveredElIndex, hover] = useState(-1);
  const onClickHandler = useCallback((rating) => () => {
    if (isActive) {
      onClick && onClick(rating);
    }
  }, [isActive, onClick]);
  const onHoverHandler = useCallback((index) => () => {
    if (isActive) {
      hover(index);
    }
  }, [hover, isActive]);
  const textSize = useMemo(() => {
    switch (size) {
      case "sm":
        return "xs";
      case "md":
        return "sm";
      case "lg":
        return "md";
      default:
        return "sm";
    }
  }, [size]);
  const defaultRating = useMemo(() => Array.from({ length: maxRating }).map((_val, index) => {
    if (hoveredElIndex === -1) {
      if (index + 1 <= currentRating) {
        return /* @__PURE__ */ React.createElement(StarFilled, {
          variant,
          size,
          key: index,
          onMouseEnter: onHoverHandler(index),
          onClick: onClickHandler(index + 1),
          onTouchStart: onClickHandler(index + 1)
        });
      }
      if (Number(`${index}.26`) <= currentRating && Number(`${index}.75`) >= currentRating) {
        return /* @__PURE__ */ React.createElement(StarHalfFilled, {
          variant,
          size,
          key: index,
          onMouseEnter: onHoverHandler(index),
          onClick: onClickHandler(index + 1),
          onTouchStart: onClickHandler(index + 1)
        });
      }
    } else {
      if (hoveredElIndex >= index) {
        return /* @__PURE__ */ React.createElement(StarFilled, {
          variant,
          size,
          key: index,
          onMouseEnter: onHoverHandler(index),
          onMouseLeave: onHoverHandler(-1),
          onClick: onClickHandler(index + 1),
          onTouchStart: onClickHandler(index + 1)
        });
      }
    }
    return /* @__PURE__ */ React.createElement(StarOutlined, {
      variant,
      size,
      key: index,
      onMouseEnter: onHoverHandler(index),
      onClick: onClickHandler(index + 1),
      onTouchStart: onClickHandler(index + 1)
    });
  }), [maxRating, hoveredElIndex, variant, size, onHoverHandler, currentRating, onClickHandler]);
  const numericRating = useMemo(() => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Text, {
    size: textSize,
    fontWeight: "bold"
  }, currentRating), /* @__PURE__ */ React.createElement(StarFilled, {
    size,
    variant
  })), [currentRating, variant, size, textSize]);
  return /* @__PURE__ */ React.createElement(StarRating$1, __spreadValues({
    isActive,
    variant,
    type
  }, rest), type === "numeric" ? numericRating : defaultRating);
};
StarRating.displayName = "StarRating";

export { StarRating };
//# sourceMappingURL=StarRating.es.js.map
